import { apiClient } from 'lib/api';

const MFA_SETUP_URL = '/users/me/mfa_setup';

function getUserMFASetupInfo(data={}) {
  return apiClient.post(MFA_SETUP_URL, data);
}

export { getUserMFASetupInfo };
